<template>
    <div class="container">
        <div class="left-cont">
            <div class="title-section" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :enter="{
                opacity: 1,
                y: 0,
            }">
                <p class="title">I code for products.</p>
                <p class="sub-title">That delight and inspire people.</p>
            </div>
            <div class="content-section" v-if="!showContactForm" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :enter="{
                opacity: 1,
                y: 0,
            }">
                <p class="description">
                    As a Full-Stack JavaScript Developer with 3+ years of experience, I have contributed to building
                    dynamic and scalable web applications. My expertise spans across both frontend and backend
                    development, creating seamless and efficient solutions for diverse projects.
                </p>
            </div>
            <div class="buttons-section" v-if="!showContactForm">
                <button class="call-btn" @click="toggleContactForm">Make a call</button>
                <button class="download-btn" @click="downloadResume">
                    <p class="tooltip">Download CV</p>
                    <div class="download-icon-wrapper">
                        <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z">
                            </path>
                        </svg>
                        <span class="icon2"></span>
                    </div>
                </button>
            </div>
            <div class="contact-forms" v-else v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible="{
                opacity: 1,
                y: 0,
            }">
                <div class="forms">
                    <div class="form-row">
                        <div class="field-wrapper">
                            <p class="label">This is</p>
                            <input class="input-text" v-model="userName" type="text" placeholder="Your Name">
                        </div>
                        <div class="field-wrapper">
                            <p class="label">Working In</p>
                            <input class="input-text" type="text" v-model="workingIn" placeholder="Your company">
                        </div>
                    </div>
                    <!-- <div class="form-row">
                        <div class="field-wrapper">
                            <p class="label">Work In</p>
                            <input class="input-text" type="text" placeholder="Your company">
                        </div>
                        <div class="field-wrapper">
                            <p class="label">&</p>
                            <input class="input-text" type="text" placeholder="Your Work Experience">
                        </div>
                    </div> -->
                    <div class="form-row">
                        <div class="field-wrapper">
                            <p class="label">Contact me at</p>
                            <input class="input-text email" type="email" v-model="emailId" placeholder="Your email id">
                        </div>
                    </div>
                    <!-- <div class="form-row">
                        <div class="field-wrapper comments">
                            <p class="label">Comments</p>
                            <textarea class="input-text textarea" rows="4"  placeholder="Your message"></textarea>
                        </div>
                    </div> -->
                </div>
                <button @click="submitQuery" :disabled="sendingRequest" class="lets-work">Let's work
                    <v-progress-circular v-if="sendingRequest" color="black" :width="2" :size="25"
                        indeterminate></v-progress-circular>
                </button>
            </div>
        </div>
        <div class="right-cont">
            <img :src="require('@/assets/images/murugesh-profile-2.png')" alt="" class="profile-img">
            <div class="icon-wrapper center">
                <img :src="require('@/assets/icons/react.svg')" alt="">
            </div>
            <div class="icon-wrapper top-left">
                <img :src="require('@/assets/icons/javascript.svg')" alt="">
            </div>
            <div class="icon-wrapper bottom">
                <img :src="require('@/assets/icons/nodejs.png')" alt="">
            </div>
        </div>

        <v-snackbar v-model="showToaster" timeout='4000' color="#252626">
            <div class="toaster-card">
                <img :src="require('@/assets/icons/success-icon.svg')" v-if="toasterType == 'success'" />
                <img :src="require('@/assets/icons/error-icon.svg')" v-else />
                <p class="toaster-text">{{ toasterMsg }}</p>
            </div>
        </v-snackbar>
    </div>
</template>

<script>

import axios from 'axios';
export default {
    name: 'IntroductionHome',
    data() {
        return {
            showContactForm: false,
            toasterType: '',
            backendUrl: process.env.VUE_APP_BACKEND_URL,
            showToaster: false,
            toasterMsg: '',
            dropdownOpen: false,
            selectedOption: '',
            needForOptions: [
                { value: 'jobOpportunity', text: 'Job Opportunity' },
                { value: 'collaboration', text: 'Collaboration' },
                { value: 'techSupport', text: 'Technical Support' },
                { value: 'general', text: 'General Inquiry' },
                { value: 'other', text: 'Other' },
            ],
            emailId: '',
            userName: '',
            workingIn: '',
            sendingRequest: false
        }
    },

    computed: {
        selectedOptionText() {
            const selected = this.needForOptions.find(option => option.value === this.selectedOption);
            return selected ? selected.text : 'Select';
        }
    },

    methods: {
        toggleContactForm() {
            this.showContactForm = !this.showContactForm;
            if (this.showContactForm) {
                this.emailId = '';
                this.workingIn = '';
                this.userName = '';
            }
        },

        onSubmit() {
            this.showToaster = true;
            this.toggleContactForm();
        },

        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectOption(value) {
            this.selectedOption = value;
            this.dropdownOpen = false;
        },

        async downloadResume() {
            axios.get(this.backendUrl + '/resume')
                .then(async (response) => {
                    const signedUrl = response.data.data.url;

                    // Create a temporary anchor element
                    const link = document.createElement('a');
                    link.href = signedUrl;
                    link.download = 'resume.pdf'; // Optional: specify the file name here

                    // Append to the body and trigger click
                    document.body.appendChild(link);
                    link.click();

                    // Clean up and remove the temporary element
                    document.body.removeChild(link);

                    this.toasterMsg = '🚀 Thanks for Downloading My CV! 🚀';
                    this.showToaster = true;
                    this.toasterType = 'success';
                    this.sendingRequest = false;
                })
                .catch(error => {
                    console.log('error', error)
                    this.toasterMsg = 'Oops! Something went wrong';
                    this.showToaster = true;
                    this.toasterType = 'error';
                    this.sendingRequest = false;
                });
        },

        validateFields() {
            if (this.userName.trim().length < 2 || this.workingIn.trim().length < 2) {
                return false;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.emailId.trim())) {
                return false;
            }
            return true;
        },

        async submitQuery() {
            this.sendingRequest = true;
            if (!this.validateFields()) {
                this.toasterMsg = 'Invalid input. Please check your fields.';
                this.showToaster = true;
                this.toasterType = 'error';
                this.sendingRequest = false;
                return;
            }

            let payload = {
                userName: this.userName.trim(),
                emailId: this.emailId.trim(),
                workingIn: this.workingIn.trim()
            };
            axios.post(this.backendUrl + '/queries', payload)
                .then(response => {
                    this.toasterMsg = 'You’re all set! We’ll be in touch soon.';
                    this.showToaster = true;
                    this.toasterType = 'success';
                    this.sendingRequest = false;
                    this.toggleContactForm();
                })
                .catch(error => {
                    this.toasterMsg = 'Oops! Something went wrong';
                    this.showToaster = true;
                    this.toasterType = 'error';
                    this.sendingRequest = false;
                });
        }
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px 120px 120px;
    display: flex;
    gap: 100px;
}


.left-cont {
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: center;
    width: 100%;
}

.right-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.title {
    font-size: 2.5rem;
    font-weight: bold;
    background: linear-gradient(125deg, #B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.sub-title {
    color: var(--primary-text-color)
}

.description {
    color: var(--secondary-text-color)
}

.sub-title {
    font-size: 42px;
    font-weight: 600;
}

.description {
    font-family: 'Poppins';
    font-size: 18px;
    line-height: 32px;
    font-weight: 400;
}

.call-btn {
    position: relative;
    font-family: 'Poppins';
    font-size: 1rem;
    font-weight: bold;
    background: linear-gradient(134.15deg, #B66BE1 24.79%, #FF6267 44.2%, #FFA84B 69.43%);
    padding: 0.6rem 1rem;
    cursor: pointer;
    border: none;

    &:before {
        position: absolute;
        content: 'Make a call';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: #fff;
        color: #0C0C0D;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(.6rem, .6rem);
        transition: transform .3s cubic-bezier(.34, 1.56, .64, 1);
    }

    &:hover:after,
    &:hover:before {
        transform: translate(0);
    }

}

.buttons-section {
    display: flex;
    gap: 32px;
    align-items: center;
}

.download-btn {
    background: transparent;
    border: none;
    padding: 0.6rem 1rem;
    color: var(--primary-text-color)
}

.profile-img {
    width: 300px;
    /* height: 300px; */
    object-fit: cover;
}


.input-text {
    border-radius: 500px;
    border: 2px solid #252626;
    background-color: #151616;
    padding: 12px;
    outline: none;
    box-shadow: 0px 0px 10px 0px #0000001A;
}

.contact-forms {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.textarea {
    border-radius: 20px;
}

.forms {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.field-wrapper {
    display: flex;
    gap: 12px;
    align-items: center;
}

.field-wrapper.comments {
    align-items: baseline;
}

.label {
    white-space: nowrap;
}

.form-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    flex-wrap: wrap;
}

.lets-work {
    padding: 10px 24px;
    border-radius: 500px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #000;
    background-color: #fff;
    border: 1px solid;
    color: #0C0C0D;
    width: fit-content;
}

.email {
    flex: 1;
}


.custom-select-wrapper {
    position: relative;
    width: fit-content;
}

.custom-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 2px solid #252626;
    border-radius: 500px;
    background-color: #151616;
    cursor: pointer;
    width: 200px;
}

.arrow {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
}

.options-wrapper {
    border-radius: 12px;
    overflow: hidden;
    background-color: #151616;
    border: 2px solid #252626;
    width: 250px;
}

.custom-option {
    padding: 12px;
    cursor: pointer;
    color: #fff;
}

.custom-option:hover,
.custom-option.selected {
    background-color: #252626;
}

.icon-wrapper {
    background: #0C0C0D;
    border: 1px solid #252626;
    border-radius: 50%;
    padding: 12px;
    display: flex;
    position: absolute;
}

.icon-wrapper img {
    width: 32px;
    height: 32px;
}

.icon-wrapper.top-left {
    top: -44px;
    left: 40px;
}

.icon-wrapper.center {
    top: 1px;
    right: -12px;
}

.icon-wrapper.bottom {
    bottom: -17px;
    right: 30px;
}

.download-btn {
    border: none;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition-duration: .3s;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.11);
}

.download-icon-wrapper {
    display: flex;
    flex-direction: column;
}

.svgIcon {
    fill: #fff;
}

.icon2 {
    width: 18px;
    height: 5px;
    border-bottom: 2px solid #fff;
    border-left: 2px solid #fff;
    border-right: 2px solid #fff;
}


.download-btn:hover {
    transition-duration: .3s;
}

.download-btn:hover .svgIcon {
    fill: rgb(255, 255, 255);
    animation: slide-in-top 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@keyframes slide-in-top {
    0% {
        transform: translateY(-10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0px);
        opacity: 1;
    }
}


@media (max-width: 1100px) {
    .container {
        padding: 2.5rem;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 32px;
        flex-direction: column-reverse;
        gap: 24px;
    }

    .call-btn {
        padding: 0.6rem;
    }

    .description {
        font-size: 1rem;
    }

    .title,
    .sub-title {
        font-size: 1.5rem;
    }

    .left-cont {
        gap: 2rem;
    }

    .icon-wrapper {
        display: none;
    }
}
</style>

<style>
.v-overlay__content {
    top: 10%;
    position: absolute;
    right: 1%;
    border-radius: 8px;
    min-width: auto;
    padding: 0 16px 0 12px;
}

.v-snack__content {
    padding: 0;
}
</style>